import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from "@angular/core";
import { AngularFireStorage, AngularFireUploadTask } from "angularfire2/storage";
import { LoadingController, AlertController, ToastController } from "ionic-angular";
import { ImageProvider } from "../../providers/image/image";
import { Observable } from 'rxjs/Observable';
import * as mime from 'mime-types';
import { DatabaseProvider } from "../../providers/database/database";

@Component({
  selector: "app-multi-file-upload-secure",
  templateUrl: "multi-file-upload-secure.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiFileUploadComponentSecure implements OnInit {
  task: AngularFireUploadTask;

  progress: any; // Observable 0 to 100
  complete: any;
  ismobile: boolean;
  imageUrl: string; // base64
  pdfUrl: string;
  downloadUrl: string;
  image_type: string = 'prescription';

  snapshot: Observable<any>;
  isHovering: boolean;

  public mobileimages = [];

  constructor(
    public storage: AngularFireStorage,
    private image: ImageProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
    private database: DatabaseProvider,
    public toastCtrl: ToastController
  ) {}

  ngOnInit() {
  }

  ngOnDestroy() {
    console.log('Destroying secure file upload component')
  }

  async createUploadTask(file: any) {
    return new Promise((resolve, reject) => {
     
      let filePath: any = null;
      filePath = `secureupload/${new Date().getTime()}_${file.name}.${file.ext}`;

      console.log("File Path: ", filePath);
      this.task = this.storage.ref(filePath).putString(file['b64'], "data_url")
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          file['url'] = u;
          file['doc_type'] = 'File - Upload'
          console.log("File Upload Complete: ", file); 
          this.cd.markForCheck();
          resolve(true);
        })
      });
      this.snapshot   = this.task.snapshotChanges();
      this.progress = this.task.percentageChanges();
    });
  }

  public uploadDesktopFiles(files: FileList) {
    const loading = this.loadingCtrl.create({});
    loading.present();

    this.processFiles(Array.from(files)).then((uploads) => {
      setTimeout(() => {


        console.log('pre loop: ', uploads, uploads.length);
        const start = async () => {
          await this.asyncForEach(uploads, async (file) => {
            await this.createUploadTask(file);
          });
          console.log('done');
          this.presentToast('File(s) were upload successfully');
          loading.dismiss();
        }
        start();
      }, 500);
      });

      //
  }

  async processFiles(files) {
    let i = [];
    await files.reduce(async (promise, file) => {
      // This line will wait for the last async function to finish.
      // The first iteration uses an already resolved Promise
      // so, it will immediately continue.
      await promise;
      this.image.getBase64(file).then((image) => {
        let filename = file.name;
        let name: any = file.name.split('.')[0].replace(' ','');
        let fileext: any = file.name.split('.')[1].replace(' ','');
        let mimetype: any = mime.lookup(fileext);
        i.push({ filename: filename, name: name, b64: image, ext: fileext, mimetype: mimetype });
      });
    }, Promise.resolve());
    return i;
  }

    // Determines if the upload task is active
    isActive(snapshot) {
      return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
    }

    toggleHover(event: boolean) {
      this.isHovering = event;
    }

  deleteImage(image)  {
    let index = this.mobileimages.indexOf(image);
    
        if (index > -1) {
          this.mobileimages.splice(index, 1);
        }
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
  
    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });
  
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/multi-file-upload-secure/multi-file-upload-secure.ts